import { Button, Modal, Paper, Slide, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import TimerIcon from '@material-ui/icons/Timer'
import { useEffect, useState } from 'react'

import { getDirection, getTranslate } from '../localization'

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: 32,
    textAlign: 'center',
    maxWidth: 420,
    width: '90%',
    outline: 'none'
  },
  icon: {
    fontSize: 48,
    color: theme.palette.warning.main,
    marginBottom: 16
  },
  title: {
    fontWeight: 'bold',
    marginBottom: 8
  },
  countdown: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: theme.palette.warning.dark,
    margin: '16px 0'
  },
  button: {
    marginTop: 16
  },
  srOnly: {
    position: 'absolute' as const,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap' as const,
    border: 0
  }
}))

type Props = {
  open: boolean
  remainingSeconds: number
  onDismiss: () => void
}

export default function IdleWarningOverlay({
  open,
  remainingSeconds,
  onDismiss
}: Props) {
  const classes = useStyles()
  const minutes = Math.floor(remainingSeconds / 60)
  const seconds = remainingSeconds % 60
  const timeDisplay = `${minutes}:${seconds.toString().padStart(2, '0')}`

  const [announcement, setAnnouncement] = useState('')
  useEffect(() => {
    if (!open) {
      setAnnouncement('')
    }
  }, [open])
  useEffect(() => {
    if (
      (remainingSeconds > 0 && remainingSeconds % 60 === 0) ||
      remainingSeconds === 30 ||
      remainingSeconds === 10
    ) {
      setAnnouncement(timeDisplay)
    }
  }, [remainingSeconds, timeDisplay])

  return (
    <Modal
      open={open}
      dir={getDirection()}
      aria-labelledby="idle-warning-title"
      aria-describedby="idle-warning-description">
      <Slide direction="down" in={open}>
        <Paper className={classes.paper} role="alertdialog">
          <TimerIcon className={classes.icon} />
          <Typography
            variant="h5"
            className={classes.title}
            id="idle-warning-title">
            {getTranslate('Session Expiring Soon')}
          </Typography>
          <Typography variant="body1" id="idle-warning-description">
            {getTranslate('Your session will expire due to inactivity.')}
          </Typography>
          <Typography className={classes.countdown}>{timeDisplay}</Typography>
          <span className={classes.srOnly} aria-live="polite" role="status">
            {announcement}
          </span>
          <Typography variant="body2">
            {getTranslate('Click below to stay logged in.')}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={onDismiss}
            autoFocus
            fullWidth>
            {getTranslate('Stay Logged In')}
          </Button>
        </Paper>
      </Slide>
    </Modal>
  )
}
